import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { IAdminSetting } from '../interfaces/IAdminSetting';
import { AdminSettingCodesEnum } from '../enums/AdminSettingCodesEnum';

export async function fetchSettings(): Promise<IAdminSetting[]> {
  return apiGet<IAdminSetting[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/settings`);
}
export async function fetchSettingById(id: string | number): Promise<IAdminSetting[]> {
  return apiGet<IAdminSetting[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/settings/${id}`);
}
export async function fetchSettingByCode(code: AdminSettingCodesEnum): Promise<IAdminSetting> {
  return apiGet<IAdminSetting>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/settings/code?code=${code}`);
}
export async function fetchSettingsValidation(): Promise<void> {
  return apiGet<void>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/settings/validation`);
}
export async function updateSetting(id: string | number, body: IAdminSetting): Promise<void> {
  return apiPut<void>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/settings/${id}`, body);
}
